  // Translation hook
import React, { useState, useCallback, useEffect, Suspense } from 'react';
import {  Route, useHistory } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Box, CircularProgress, Typography, Grid, Button } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { blue, red } from '@mui/material/colors';

// Styles
import './App.css';
import useStyles from './styles';

// Hooks
import useUIState from './hooks/useUIState';
import useUser from './hooks/useUser';
import useProducts from './hooks/useProducts';
import useCart from './hooks/useCart';
import  useUserCountry from './hooks/useUserCountry.js';

// Translation
import { useTranslation } from 'react-i18next';

import { Daabia, product,dbstore } from './daabia/daabia.js';

// Services and utils
import { axiosClient, axiosPiClient, config } from './services/axiosClient';
import { getDeviceType } from './utils/Utils';
import {detect} from 'detect-browser';

// Daabia domain
//import Daabia, { product, store } from './daabia/daabia.js';
import { cartObj } from './tmpObject';

// Components
import LogIn from './pages/login/LogIn';
import SignUp from './pages/signup/SignUp';
import Settings from './settings/Settings';
import NestedList from './components/category/nestedList/NestedList';
import { Topbar, TopbarcontacInfo, BottomNav, Products, Search, Store, NewStore, MyStore, Cart, Orders, ProceedCheckOut, Account, Herosection, Footer, AboutUs, PmNewProduct, PmProduct, PmProductList, Transactions, Withdraw, Confirm, Medalalerts, Privacy, ContactUs } from './components';
// ...existing code...
import OrderDetails from './components/orders/details/OrderDetails';
import Policyterms from './components/modal/policyTerms/Policyterms';
import UpdateBrowserModal from './components/modal/UpdateBrowserModal';
import TopBarFallback from './components/topbar/TopBarFallback.jsx';
import Notification from './components/notification/Notification.jsx';
import AccountPanel from './components/account/accountpanel/AccountPanel.jsx';
import AlertDialog from './components/alertdialog/AlertDialog.jsx';
import ProductsGridFallback from './components/products/ProductsGridFallback.jsx';
import EmptyProducts from './components/products/EmptyProducts.jsx';
import Details from './components/productManager/transactions/details/Details.jsx';
import CheckOut from './components/checkoutform/checkout/CheckOut.jsx';
import BottomNavFallback from './components/bottomnavigation/BottomNavFallback.jsx';
import CustomizedSnackbar from './components/snackbar/CustomizedSnackbar.jsx';
import CloudTranslatejs from './translations/Cloudtranslatejs.js';
import usePiAds from './hooks/usePiAds.js';
import Terms from './components/terms/Terms.jsx';
import CountryScopeSelector from './components/countryScopeSelect/CountryScopeSelector.jsx';
import Login from './components/account/Login.jsx';
import { LoginModal } from './components/modal/LoginModal.jsx';
import ReactCountryFlag from 'react-country-flag';
import logToGoogleSheet from './utils/SendLogs.js';
function App() {
  
  // Translation hook (must be inside component)
  const {loading ,usercountryscope,setUsercountryscope} = useUserCountry();


  // Initialize Pi SDK once on mount
  React.useEffect(() => {
     // const ticker = getTicker
     // ('c55683aaf175c34805747c9c48c6bce012803ab093a5064171814184b0632903','GHS','PI',10);
//    if (window.Pi && typeof window.Pi.init === 'function') {
      window.Pi.init({ version: "2.0", sandbox: process.env.NODE_ENV ==="development" ? true :false});
   // }
  }, []);

   const [t,i18n] = useTranslation('common');
  
  // ...existing code...
  // UI state managed by useUIState
  const ui = useUIState();
  const {
    showprogress, setShowProgress, setOpenModal,
    openMedalModal, setOpenmedalmodal,
    openLoginModal,setOpenLogInModal,
    openBrowserModal, setOpenBrowsermodal,
    openPrivacyModal, setOpenprivacymodal,
    openSnackBar, setOpenSnackBar,
    message, setMessage,
    showAddresses, setShowAddresses,
    addAddress, setAddaddress,
    selectedOrder, setSelectedOrder,
     setSelectedGroup,
     setPrivacyterms,
    isUserSearching, setIsUserSearching,
    keyboardVisible, setKeyboardVisible,
    openBrowserUpdateModal, setOpenBrowserUpdatemodal,
     setShowModal,
    isOrdersSorted, setisOrdersSorted,
    appcredits, setAppcredits,
    nextClaimAvailable, setNextClaimAvailable,
    addresses, setAddresses,
    order, setOrder,
    storeProducts, setStoreProducts,
    store,setStore,
    stores, setStores,
    sales, setSales,
    account, setAccount,
    balance, setBalance,
    notification, setNotification,
    isCategoryGroupLoaded, setIsCategoryGroupLoaded,
    isCategoryLoaded, setIsCategoryLoaded,
    isProductsLoaded, setIsProductsLoaded,
    isRecentProductsLoaded, setIsRecentProductsLoaded,
    isCartsLoaded, setIsCartsLoaded,
    isOrdersLoaded, setIsOrdersLoaded,
    isSlidesLoaded, setIsSlidesLoaded,
    isLinksLoaded, setIsLinksLoaded,
    isUserCountryLoaded, setisUserCountryLoaded,
    istempTokenLoaded, setIstempTokenLoaded,
    isFavoritesLoaded, setIsFavoritesLoaded,
    isStoreBalanceLoaded, setIsStoreBalanceLoaded,
    
  } = ui;
 const { isAdNetworkSupported: piAdsSupported, showPiAds, showRewardedPiAds } = usePiAds({t,setMessage,setOpenSnackBar,setAppcredits, setNextClaimAvailable, setOpenmedalmodal,setShowProgress});
  // User logic extracted to custom hook
  const {
    userid,
    userObj,
    user,
    isAuthenticated,
    loggedin,
    isUserObjSet,
    tempUserToken,
    // istmpTokenLoaded, // unused
    favorites,
    sessionVersion,
    isSessionVersionSet,
    setUserid,
    setUserObj,
    setUser,
    setLoggedin,
    setIsUserObjSet,
    setTempUserToken,
    setIsAuthenticated,
    // setIstmpTokenLoaded, // unused
    setFavorites,
    setIsSessionVersionSet,
    setSessionVersion,
    handleLoadUser,
    signIn,
    // signInUser, // unused
    handleLogOut,
    // logOut, // unused
    authenticateToken,
    // hanldegetAccessToken, // unused
    // getAccessToken, // unused
  } = useUser({showPiAds,setShowProgress,setOpenLogInModal});

  
     const[addedLimit]=useState(2)
    
     
     const[groupCategories,setgroupCategories]=useState();
     const[categories,setCategories]=useState();
     const[orderCount,setMyOrderCount]=useState(-1);
       const[openReviewDialog,setOpenReviewDialog]=useState(false);

     const[LoadingMore,setLoadingMore]=useState(false)
     const [deviceType]=useState(getDeviceType()) //tablet mobile desktop
     const [showCategory,setShowCategory]=useState(false)
     const [showNotification,setShowNotification]=useState(false)
     const [slidesImages,setSlidesImages]=useState();
     const[isStoresLoaded,setIsStoresLoaded]=useState(false);
     
     const [storeTransactions,setStoreTransactions]=useState([])
     const [productCategories,setProductCategories]=useState([]);
     const [emailverified,setEmailVerified]=useState(false)
     const [browser,setBrowser]=useState('')
     const[visited,setVisited]=useState(false)
     const[claimedReward,setClaimedReward]=useState( JSON.parse(localStorage.getItem('pref')) ?JSON.parse(localStorage.getItem('pref')).claimed:false)
     const[isAdNetworkSupported,setIsAdNetworkSupported]=useState(localStorage.getItem('adNetworkSupported') ?localStorage.getItem('adNetworkSupported') :false)
    

     const [langcode,setLangCode] = useState(localStorage.getItem('userLanguageChoice')? localStorage.getItem('userLanguageChoice') :'en');
     //tranx page options
     const [page,setPage]=useState(1)
     const [perPage,setPerPage]=useState(100)
     const [showAds,setShowAds]=useState(true)
     //subscriptions monitoring states
         const[isStoreTransLoaded,setIsStoreTransLoaded]=useState(false)
         const[isStoreProductsLoaded,setIsStoreProductsLoaded]=useState(false)
     const[isNotificationsLoaded,setIsNotificationsLoaded]=useState(false)
     const[accessToken]=useState(localStorage.getItem('accessToken'));
     const[medialinks,setMedialinks]=useState()
     const [adsImages]=useState([])
     const [showprofile,setShowProfile] =useState(false)   
     const [openCountrySelect,setOpenCountrySelect]=React.useState(false)
     const[iscompletePayment,setisIncompletePayment]=useState(false);
     const[isA2ucompletePayment,setisA2uIncompletePayment]=useState(false);
     const [selectedTransaction,setSelectedTransaction]=useState()
     const [waitonCustomer,setWaitOnCustomer]=useState(false)
      

  const ref = React.useRef();

  const theme = createTheme({
    palette: {
      primary:{
        main:"#6d1b7b"
       /* main:"#CC61CF",
        main:"#faa532", */
       /*  , */
      /*   main:"#ff9800", */
      },primarybackground:{
        main:'#cb61cfea',
        ontrastText:'#fff'
      },
        secondary: {
            main:'#ddbbdd'/* red[500] */,
            contrastText:'#fff'
        },
        warning:{
          main:red[100],
          contrastText:'#fff'
        },
        price:{
          main:red[500],
          contrastText:"#fff"
        },
        link:{
          main:blue[100],
          contrastText:'#fff'
        },
        info:{
          main:"#6d1b7b",
         /*  main:"#c75bda", */
         contrastText:'#fff'
        },
        Paid:{
          main:"#2a7ade",
          contrastText:'#fff'
        },
        Shipped:{
          main:"#d39012",
          contrastText:'#fff'
        },
        Recieved:{
          main:"#8fd312",
          contrastText:'#fff'
        },
        Completed:{
          main:"#34af4d",
          contrastText:'#fff'
        },
        
        Cancelled:{
          main:"#af3c34ca",
          contrastText:'#fff'
        },
        textDark:{
          main:"darkgray",
          contrastText:'#fff'
        },
        textGrey:{
          main:"darkgray",
          contrastText:'#fff'
        },
       lightGrey:{
         main:'#a9a9a933',
         contrastText:'#fff'
        },
        textWhite:{
          main:'#ffffff',
         }
        
      },
});   


  
    const scrollToSection = (sectionId) => {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth',inline:'start' });
      }
    };
  
      
   const createTempUserId= ()=>{
     var id='';
    if (localStorage.getItem('_id')!==null){
      let uid=localStorage.getItem('_id');
      let loggedin=localStorage.getItem('loggedin');
      if (loggedin!==null){
        if (loggedin==='true'){ //if user signed In get user Id from locaStorage
          //console.log(uid)
       id=uid; 
      //localStorage.removeItem('temp_id');

     }else if(loggedin==='false'){
      id=localStorage.getItem('temp_id');
      
     }
     }
    }
     //console.log(id)
     return id;
  }
     // Product and cart state now managed by hooks
     const productsHook = useProducts();
     const cartHook = useCart(userid, setShowProgress, setOpenSnackBar, setMessage, t,signIn,setOpenLogInModal);

     // Example usage:
     // const { products, setProducts, recentProducts, ... } = productsHook;
     // const { cart, setCart, addtoCart, ... } = cartHook;
     const {
       products,
       setProducts,
       recentProducts,
       setRecentProducts,
       filteredProducts,
       setFilteredProducts,
       recommendedProducts,
       setRecommededproducts,
       popularProducts,
       setPopularproducts,
       bestSellers,
       setBestSellers,
       mProduct,
       setmProduct,
       prodsPage,
       setProdsPage,
       prodsPerpage,
       setProdsPerpage,
       limit,
       setLimit,
       noMoreProducts,
       setNomoreProducts,
       showRecent,
       setShowRecent,
       recentPtmpCount,
       setrecentPtmpCount,
       recentPCount,
       setrecentPCount,
       fetchProduct,
       searchProduct,
     } = productsHook;

     const {
       cart,
       setCart,
       itemsCount,
       setItemsCount,
       handleAddtoCart,
       handleRemoveFromCart,
       handleUpdateCartQty,
       emptyCart,
       handleupdateSelection,handleupdateColorSize
     } = cartHook;
   // Use Pi Ads hook
   
     // ...existing code...
    // Function to handle focus event
    const handleFocus = () => {
        setKeyboardVisible(true);
        //console.log("Keyboard is visible");
    };
    // Function to handle blur event
    const handleBlur = () => {
        setKeyboardVisible(false);
        console.log("Keyboard is hidden");
    };

     // Fix undefined variables
     // storeindex: index of current store, default to 0
     const [storeindex, setStoreindex] = useState(0);
     // usercountryscope: array of country scopes, default to []
     // myOrders: user's orders, default to []
     const [myOrders, setMyOrders] = useState([]);
     // nextstep: function to proceed after order, default to noop
     let nextstep = () => {};
     // neworder and shippingdata: used in order flow
     let neworder = null;
     let shippingdata = null;
     // refreshCart: from cartHook
     const { refreshCart } = cartHook;
     const paths=['/','/products','/store','/store/:tag',/* '/new-product','/new-store','/edit-product','/transactions', */'/cart',/* '/checkout', */'/orders','/proceedcheckout','/prefaredstylecheckout','/account'];
     const topbarpaths=['/','/products'];
     const pmpaths=['/product-list','/new-product','/new-store','/edit-product','/transactions','/withdraw'];
     //https://xoomato.com/j3c5o
     const [hoplinks]=useState(["https://www.google.com/url?sa=t&source=web&rct=j&url=https://pi-fiat-currency-converter.herokuapp.com/&ved=2ahUKEwjX0JKRkOP_AhW3VqQEHXViCzgQFnoECCkQAQ&usg=AOvVaw3LZkakbCu4BvKnbt3fQ_qo","https://play.google.com/store/apps/details?id=com.naeatestudio.pifiatconverter&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1","https://3ba1dhl0elfs2nddh32fizeyaa.hop.clickbank.net","https://c07917e9krok5o0wmgy5o1vqa7.hop.clickbank.net","https://0343dlb6cofu1z9-dd9g0554xw.hop.clickbank.net"])
     const classes =useStyles()
     let history = useHistory();
     const handleCloseModal = () =>{ 
      setOpenModal(false);
      setOpenLogInModal(false);
      setShowProgress(false);
    }
    const handleCloseMedalModal =() =>{
      setOpenmedalmodal(false);
    }
    const translateStatus = (title)=>{
      var text=''
     switch (title) {
      case 'Paid':
          text = t('form.product.status.paid')
        break;
      case 'Shipped':
          text = t('form.product.status.shipped')
        break;
      case 'Recieved':
          text = t('form.product.status.recieved')
        break;
        case 'Completed':
          text = t('form.product.status.completed')
        break;
      default:
        break;
     }
     return text
    }
     const handleNavigatePage = (path)=>{
    //navigate to product page
   history.push(path);

}
    const handleSignIn =() =>{
  const browserlist = ['ios-webview','chromium-webview']
  try {
       var scopes =["username","payments","wallet_address"]
    if(!browserlist.includes(browser.name) && process.env.NODE_ENV === 'production') {  
 /*  signIn(scopes)  */
      const url = `${process.env.REACT_APP_CLIENT_PINET_URL}/`
      console.log(url)
      // history.push(url) 
      window.location.href = url
 }else{
  signIn(scopes,onIncompletePaymentFound) 
 }
  } catch (error) {
    console.log(error)
  }
}
    const handleCloseBrowserModal =() =>{
        history.push(`${process.env.REACT_APP_CLIENT_PINET_URL}`)
      setOpenBrowsermodal(false);
    }
    
     const privacyAction = (action,option)=>{
        if (user._id && action ==='agreed'){
          axiosPiClient.patch(`/user/privacyterms/${user._id}`, {option:option},config).then((response)=>{
            if (response.status===200){
              const userObj = response.data;
              localStorage.setItem('user', JSON.stringify(userObj));
              setUserObj(response.data); 
              setUser(userObj.user)
              localStorage.setItem('privacyterms',JSON.stringify({policy:userObj.user.accept_privacy_policy,terms:userObj.user.accept_privacy_policy}))
              setPrivacyterms({policy:userObj.user.accept_privacy_policy,terms:userObj.user.accept_privacy_policy})
             if(option ==='terms'){ 
              setOpenprivacymodal(false)
            }
            }
      })
        }else{
           setOpenprivacymodal(false)
        }
     }
    const  handleOnBottomNavChange = async(value) => {
      if(value===0){
        history.push('/')
        setIsUserSearching(false)
        setShowRecent(true)
      }else if (value===1){
        if (localStorage.getItem('loggedin')==="true"){
          history.push('/cart')
          }else{
            history.push('/account')
           // setOpenModal(true)
          }
      }else if (value===2){
        if (stores[storeindex].status==='Verified'){
          history.push(`/new-product/${stores[storeindex]._id}`)
        }else{
          try{
            await fetchStoresStatus(user).then((response)=>{
              if (response.status ===200)
              var store_ = response.data.store[0];
                localStorage.setItem('stores',JSON.stringify(response.data.store))
                setStores(response.data.store)//reppace updated store
               if (response.data.store.length >0){
                if (store_.status==='Verified'){
                 history.push('/new-product')
                }else{
                 setMessage({body:t("alerts.not_verified_store"),severity:'info'})
                 setOpenSnackBar(true)
                }
               }
            });
           }catch(error){
           }
        }
      }else if (value===3){
        if (localStorage.getItem('loggedin')==="true"){
          setisOrdersSorted(false)
          history.push('/orders')
          }else{
            history.push('/account')
          }
      }else if (value===4){
        history.push('/account') 
      }
    }
    if (history.location.pathname ==='/products' && filteredProducts.length <=0){
      

      history.push('/') // loads home on products page reload if no search results found 
      
  }
    const handleUserClick = () =>{
     if(localStorage.getItem('loggedin')==="true"){
      history.push('/account') 
     }else{
      /*   signIn()
      setOpenModal(true) */
     }
    }
    const loadMore = () =>{
     
     /*  if (recentProducts.length >=20 ){
        addlimit=limit+10
        setLimit(addlimit);
      } */
       

      console.log(recentPCount + " " +recentPtmpCount)
     if (usercountryscope){
       if (usercountryscope.length >0){
        loadMoreRecentProductsOrderbyScope(prodsPage)
      }else{
         loadMoreRecentProducts(prodsPage)
      }
     }
     
     

    }

   

 
     //pi pyaments
    // User authentication logic now managed by useUser hook

    const resetSubscriptions = () =>{
      setIsCategoryGroupLoaded(false)
      setIsCategoryLoaded(false)
      setIsProductsLoaded(false)
      setIsRecentProductsLoaded(false)
      setIsCartsLoaded(false)
      setIsOrdersLoaded(false)
      setIsSlidesLoaded(false)
      setIsLinksLoaded(false)
      setisUserCountryLoaded(false)
      setIstempTokenLoaded(false)
      setIsUserObjSet(false)   
      setIsFavoritesLoaded(false)
      setIsStoreBalanceLoaded(false)
     // setIsOrdersCountset(false)  
      setIsStoresLoaded(false)
         // setisIncompletePayment(false)


    }
  
   /*  const signOutUser = async () => {
      setShowProgress(true)
      await axiosClient.get('/user/signout',{},config).then((response)=>{
        setShowProgress(false)
      setUserObject(null)
      setUser(null);
      setCart([]);
      setOrder([]);
      setStores([]);
      setItemsCount(0)
      resetSubscriptions()
      });
      
    } */
  const onIncompletePaymentFound = useCallback( (payment) => {
      console.log("onIncompletePaymentFound", payment);
      return axiosPiClient.post('/payments/incomplete', {payment},config).then((response)=>{
            if (response.status===200){
              const completedorder=response.data.completedorder
              setCart(response.data.cart);
              setMyOrders(myOrders=>[...myOrders,completedorder]);
            }
      })
    },[setCart])
   
    const checkInCompletePayments = useCallback(async()=>{
      
            if (window.Pi && typeof window.Pi.init === 'function') {

      const scopes = ["payments","username","wallet_address"];
     await window.Pi.authenticate(scopes, onIncompletePaymentFound);
    }
   },[onIncompletePaymentFound])

  const checkA2uInCompletePayments = useCallback(async()=>{
    
    await axiosClient.get('/payments/a2u/incomplete',{},config).then((response)=>{
    });
 },[])
    const handleRefund = (customeruid,amount,productid,ordernumber,memo)=>{
     
     
      if (user){ 
         if(amount > -0){
          setShowProgress(true)
          const url =`/payments/a2u/refund`
          axiosPiClient.post(url,{amount:amount,uid:customeruid,productid:productid,ordernumber:ordernumber,memo:memo},config).then((response=>{
                 setShowProgress(false)
                 if (response.data.status===200){
                  setMessage({body:`${CloudTranslatejs(localStorage.getItem('userLanguageChoice'),t,'Cancel and Refunded successfully')}`,severity:'success'})
                  setOpenSnackBar(true)   
                }else if (response.data.status===201){
                  setMessage({body:`${CloudTranslatejs(localStorage.getItem('userLanguageChoice'),t,response.data.message)}`,severity:'info'})
                  setOpenSnackBar(true)   
                }else if(response.data.status===203){
                  setMessage({body:`${CloudTranslatejs(localStorage.getItem('userLanguageChoice'),t,response.data.message)}`,severity:'info'})
                  setOpenSnackBar(true)   
                }
            }))
         }else{
          setMessage({body:t("alerts.invalidamount"),severity:'error'})
                 setOpenSnackBar(true)  
         }
      }
        
    }
    const composeAndSendNotification = async(orders) =>{
      const title=t('order.neworder')
      for (let i=0;i<orders.length;i++){
        const message = `${t('alerts.neworder_message')} #${orders[i].orderNumber} `
 
        handlepostMessage(order.storeId,order.productId,{title:title,content:message,link:'/orders'},true)
      }

    }
    const orderProduct = async (newOrder,shippingData) => {
       if(user === null) {
        return setShowModal(true);
      }
      var amount=newOrder.shipping.amount
      //var customer=newOrder.customer;
      var items=newOrder.line_items
       neworder= newOrder
       shippingdata = shippingData
          let itemNames = []
             items.forEach(item =>{
                 if (item.selected===true){
                  itemNames.push(item.product.name)
                 }
             });
          const memo= itemNames.toString()

     
      const paymentData = { amount, memo, metadata: newOrder };
           console.log(paymentData)
           /* axiosPiClient.post('/orders',paymentData,config).then((re)=>{

           }) */
      
      const callbacks = {
        onReadyForServerApproval,
        onReadyForServerCompletion,
        onCancel,
        onError
      };

      
     try{
      const payment = await window.Pi.createPayment(paymentData, callbacks);
      console.log(payment);
        
     }catch(err){
     /*  setMessage({body:` consent required`,severity:'info'})
       setOpenSnackBar(true)   */
      const scopes = ["payments","username","wallet_address"];
      signIn(scopes)
       
      console.log(err)
     }
    }
   
    
  
    const onReadyForServerApproval = (paymentId) => {
      console.log("onReadyForServerApproval", paymentId);
      axiosPiClient.post('/payments/approve', {paymentId}, config);
    }
  
    const onReadyForServerCompletion = (paymentId, txid) => {
      console.log("onReadyForServerCompletion", paymentId, txid);
      const userid=user._id
      axiosPiClient.post('/payments/complete', {paymentId, txid,userid}, config).then((response)=>{
         
        console.log(response)
        if (response.data.status===200){

          setMyOrders(response.data.orders);
          composeAndSendNotification(response.data.orders)
          sendMerchantOrderNotificationEmail(response.data.orders)
          //setMyOrderCount(response.data.orders.length);

             if (addresses.length === 0){//no address is saved add new
              handlesetAddress(user._id,shippingdata)
            }else{
                if (addAddress){handlesetAddress(user._id,shippingdata)}//user clicking on add button at addresses page set @showAddresses to false ,address will not be saved
            }
       
        setOrder(neworder);
         sendOrderConfirmationEmail(userid,neworder) 
         sendOrderConfirmationSMS(response.data.orders)  
                 
          if (typeof refreshCart === 'function') refreshCart();
          if (typeof nextstep === 'function') nextstep(); //proceed and record order
        }else if(response.data.status === 400){
          setMessage({body:response.data.message ,severity:'info'})
          setOpenSnackBar(true)
        }
      })
    }
  
    const onCancel = (paymentId) => {
      console.log("onCancel", paymentId);
      return axiosPiClient.post('/payments/cancelled_payment', {paymentId});
    }
  
    const onError = (error, payment) => {
      console.log("onError", error);

      if (payment) {
        console.log(payment);
        // handle the error accordingly
      }
    }
  
  



    
    // ...existing code...
    const handlerequestRefund = async (ord) => {
      console.log(ord.requestRefund)
      console.log(!ord.requestRefund)
      setShowProgress(true)
      try {
        const response = await axiosClient.patch(`${process.env.REACT_APP_SERVER_URL}/orders/requestrefund/${ord._id}/${user._id}`, { requestRefund: !ord.requestRefund }, config);
        setShowProgress(false);
        if (response.data.status === 200) {
          const orders = response.data.orders;
          setSelectedOrder(orders.filter((o) => o._id === ord._id)[0]); //setSelected order to update ui
          setMyOrders(orders);
          setMessage({ body: ord.requestRefund ? t("alerts.refundrequested") : t("alerts.refundcancelled"), severity: 'info' });
          setOpenSnackBar(true);
        }
      } catch (err) {
        setShowProgress(false);
        console.log(err);
      }
    }

    // handleLogOut and logOut are now provided by useUser hook
    const sendOrderConfirmationEmail = (_id,newOrder)=>{
     //console.log("id "+_id + "email "+newOrder.customer.email)
      const url = `${process.env.REACT_APP_SERVER_URL}/email/confirmorder/${_id}`;

    axiosClient.post(url,{email:newOrder.customer.email,data:newOrder},config).then((response)=>{
        console.log(response); 
        setOrder([])
    })
  }

  const sendMerchantOrderNotificationEmail = (orders)=>{
    //console.log("id "+_id +"email "+newOrder.customer.email)
     const url = `${process.env.REACT_APP_SERVER_URL}/email/merchantOrderNotification`;

   axiosClient.post(url,{orders:orders},config).then((response)=>{
       console.log(response); 
       setOrder([])
   })
 }


  const sendOrderConfirmationSMS = (orders)=>{

     const url = `${process.env.REACT_APP_SERVER_URL}/sms/`;

   axiosClient.post(url,{orders:orders},config).then((response)=>{
       console.log(response);
   })
 }
  const handleConfirmedUser = (email)=>{
    setShowProgress(true)
    const url=`${process.env.REACT_APP_SERVER_URL}/email/confirm/${user._id}`
    return axiosClient.post(url,{email:email,uid:user.uid},config)
   }
  const handleSendConfirmationCode = (email,code)=>{
   /*  console.log(email)
    const code= randNumber(4) */
    
    
     const url = `${process.env.REACT_APP_SERVER_URL}/email/code`;
 
     axiosClient.post(url,{_id:user._id,email:email,code:code},config).then((response)=>{
    setShowProgress(false)
       console.log(response)
       setMessage({body:t("alerts.confirmation_code_sent"),severity:'info'})
       setOpenSnackBar(true)
   })
 }

  const handlesetAddress = (_id,address)=>{
       console.log(_id)
       const url = `${process.env.REACT_APP_SERVER_URL}/user/shippingaddress/${_id}`;
       
       axiosClient.post(url,{address:address},config).then((response)=>{
       const user      = response.data.user
       const addresses = user.addresses

       localStorage.setItem('user',JSON.stringify(response.data));
       setAddresses(addresses);
       setShowAddresses(true);
       setAddaddress(false)
   })
 }
 const handleDeleteAddress = (_id)=>{
  const url = `${process.env.REACT_APP_SERVER_URL}/user/shippingaddress/${user._id}`;
    
  axiosClient.patch(url,{_id:_id},config).then((response)=>{
    console.log(response);
    const user = response.data.user
    localStorage.setItem('user',JSON.stringify(response.data));
    setAddresses(user.addresses);
   
})
}

const updateCartItems = async (itemIds,qtys)=>{
  const url = `${process.env.REACT_APP_SERVER_URL}/carts/update/items`;
    
   await  axiosClient.patch(url,{userId:user._id,itemIds:itemIds,itemQuantitys:qtys},config).then((response)=>{
   if (response.data.status === 200){
    //console.log(response);
    setCart(cartObj)
    setTimeout(()=>{
      setCart(response.data.cart)
       
    setMessage({body:t("alerts.cart_item_updated"),severity:'info'})
    setOpenSnackBar(true)
    },0)
   
   }
})
}

const rateStore = async (storeId,rate)=>{
  const url = `${process.env.REACT_APP_SERVER_URL}/storerating/`;
    
   await  axiosClient.post(url,{userId:user._id,storeId:storeId,rate:rate},config).then((response)=>{
   if (response.data.status === 200){
   
    /* setMessage({body:`${response.data.message}`,severity:'info'})
    setOpenSnackBar(true) */
  
   
   }
})
}
const rateProduct = async (productId,storeId,rate)=>{
  const url = `${process.env.REACT_APP_SERVER_URL}/productrating/`;
    
   await  axiosClient.post(url,{userId:user._id,productId:productId,storeId:storeId,rate:rate},config).then((response)=>{
   if (response.data.status === 200){
   
    /* setMessage({body:`${response.data.message}`,severity:'info'})
    setOpenSnackBar(true) */
  
   
   }
})
}
const getIsStoreRated = async ()=>{

  const response =isStoreRated().then((response)=>{
    if (response.data.status === 200){
       console.log(response.data.rating)
       //setRatedValue (response.data.rating[0].rate)
     /* setMessage({body:`${response.data.message}`,severity:'info'})
     setOpenSnackBar(true) */
 
    
    }else{
     //setRatedValue(response.data.rating[0].rate)
 
    }
 })
}
const isStoreRated = async (storeId)=>{
  const url = `${process.env.REACT_APP_SERVER_URL}/storerating/checkisuserrated`;
    
  return await  axiosClient.post(url,{userId:user._id,storeId:storeId},config);
}
const handleonGroupExpandClick =(group)=>{
  console.log(group._id)
  setSelectedGroup(group);
  const filtered=categories.filter((item) =>item.categoryGroupId === group._id)
  // Cart and product logic now handled by useCart and useProducts hooks
  
  };
   

  const handleUpdateLikes = async (productId,storeId)=>{
     /* if(localStorage.getItem('loggedin')==='true'){//sign in user can like and add to fovorites
      updateLikes(productId,storeId).then((response) => {
       // console.log(response.data);
        if (response.status===200){
     
  
        }
      }) 
      }else{
        console.log('user not loggedin')
      } */
  }
  
  
    
  
    const updateLikes =(productId,storeId)=>{
      
      const url = `${process.env.REACT_APP_SERVER_URL}/productlikes/${productId}`;
   
      return axiosClient.post(url,  {
        productId:productId,
        storeId:storeId,
        email:user.email,
        
       
      },config)
    
    };

    //update order  status
const handleUpdateOrder=(orderid,storeId,status)=>{ 
  console.log(status)
     setShowProgress(true)
     updateMyOrder(orderid,storeId,status).then((response) =>{
     setShowProgress(false)
     const orders=response.data.orders;
     setisOrdersSorted(false);
     console.log(orders.filter((o)=>o._id===orderid)[0])
     setSelectedOrder(orders.filter((o)=>o._id===orderid)[0])//setSelected order to update ui

     if (status==='Recieved'){     
        updateAppcredits(1,'recievedOrders')
    }
    setMyOrders(orders)//set my order data  with new updated one  
  });
}




const updateMyOrder =(orderid ,storeId,status)=>{
const url = `${process.env.REACT_APP_SERVER_URL}/orders/${orderid}/${userid}`;
 
const body={
       status:status,
       storeId:storeId
    
}
   
const config = {
  headers: {
      'auth-token':  userObj !==null ? userObj.auth_token : tempUserToken,
    },
    timeout: 20000, withCredentials: true,credentials: "include"
}
return axiosClient.patch(url, body,config)

};
   
  const incomingOrder = async (newOrder)=>{

    var amount  =newOrder.amount
    var customer=newOrder.customer;
    var items=newOrder.line_items
    var shippingData=newOrder.shipping
    var paymentMethod=newOrder.shipping.paymentMethod
     
        let itemNames = []
           items.forEach(item =>{
               itemNames.push(item.product.name)
           });
        let memo= `paying for ${itemNames.toString()}`
            

    const url     = `${process.env.REACT_APP_SERVER_URL}/orders`;
    const accessToken=localStorage.getItem('accessToken')
    const options = {
          headers:{
            Authorization:`Bearer ${accessToken}`
            
          },timeout: 20000, withCredentials: true,credentials: "include"
        }

      var response='';
      for(let i=0;i<items.length;i++){
        if(items[i].selected){//make order fro only selected items

          await  axiosClient.post(url,  {
            name:items[i].product.name,
            storeId:items[i].product.storeId,
            productId:items[i].product._id,
            orderNumber:shippingData.orderNumber,
            orderType:items[i].product.product_type,
            quantity:items[i].quantity,
            color:items[i].color,
            size:items[i].size,
            measurement:items[i].measurement,
            productImageUrl:items[i].product.image[0].secure_url,
            products3ImageUrl:items[i].product.s3Image  && items[i].product.s3Image[0].url ? items[i].product.s3Image[0].url : '',
            priceEach:items[i].product.price,
            shippingFees:items[i].line_item_sub_fees,  
            shippingDuration:items[i].product.shippingDuration ? items[i].product.shippingduration : 1,
            totalPrice:items[i].line_item_sub_price,
            userId:userid,
            paymentMethod:'pipayments',
            firstname:customer.firstname,
            lastname:customer.lastname,
            email:customer.email,
            phone:customer.phone,
            country:shippingData.country,
            state:shippingData.county_state,
            city:shippingData.town_city,
            street:shippingData.street,
            homeAddress:shippingData.home_address ,
          // eslint-disable-next-line no-loop-func
          },options).then(ret=>{
            console.log(ret)
            response= ret;
          })
        }

      }

      return response
  


    
  }
 
  const handleCaptureCheckout =async (checkoutTokenId,newOrder,shippingData,backStep,nextStep)=>{
   
    try{  
      
                nextstep=nextStep
             orderProduct(newOrder,shippingData)

        
       }catch(error){
      console.log(error.data.error.message)
    }
}
  
const handlegetProduct = async (productid)=>{
           
  fetchProduct(productid).then((response) => {
    
    if (response.status===200){
       
      try{
        setmProduct(response.data.product)
       
      }catch(err){
        console.log(err)
      }
    }
    
  })

}


const fetchStoreProducts = async ()=>{
  try{
    const url=`${process.env.REACT_APP_SERVER_URL}/products/store/${stores[storeindex]._id}`
     return await axiosClient.get(url,{},config);
    /*  const res = await fetch(`${process.env.REACT_APP_SERVER_URL}/products/store/${stores[storeindex]._id}`);
     const data=await res.json();
           console.log(data)
           return data.products; */
  }catch(error){

  }
}
const handlegetStoreProducts = async ()=> {

try{
   await fetchStoreProducts().then((response)=>{
    setShowProgress(false)
    setStoreProducts(response.data.products)
   })
   

}catch(error){
  console.log(error)
}
}

  const  handleDeleteStoreProduct = async(_id)=> {
        try {
          const response = await axiosClient.delete(`${process.env.REACT_APP_SERVER_URL}/products/${_id}`,{},config);
          console.log(response);
          if(response.data.status === 400){
            setMessage({body:t("alerts.cannot_delete_product"),severity:"error"})
            setOpenSnackBar(true)
          }else
          if (response.data.deletedCount>=1){
          setStoreProducts(storeProducts.filter((item) => item._id !==_id))

          }
        } catch (error) {
          console.error(error);
        }
      }   
      const handlegetTransactions =  async (page,perPage) => {//get Orders 
          if(stores && stores[storeindex] ){
                 setShowProgress(true)
        var url = `${process.env.REACT_APP_SERVER_URL}/analytics/transactions/${stores[storeindex]._id}/${page}/${perPage}`
    
        await axiosPiClient.get(url,config).then((response)=>{
              //setShowProgress(false)
                //setAnalytics(response.data);
                //setSales(response.data.total[0])
                const txts=response.data.transactions
               setStoreTransactions(response.data.transactions);
              //console.log(response.data.transactions.length)
              handlegetSales()
              handlegetStoreAccountBalance()
       });
     }
    }

     const handlegetCurrensessionUser =  async () => {//get Orders 
      setShowProgress(true)
var url = `${process.env.REACT_APP_SERVER_URL}/session/currentuser/${stores[storeindex]._id}`

await axiosClient.get(url,{},config).then((response)=>{
  //setShowProgress(false)
  console.log(response)
    
});
}

     const handlegetSales =  async () => {//get Orders 
     // setShowProgress(true)
    var url = `${process.env.REACT_APP_SERVER_URL}/analytics/sales/${stores[storeindex]._id}`

      await axiosClient.get(url,config).then((response)=>{
      setShowProgress(false)
        setSales(response.data.total[0])
});
}
 

//Transactions
const handleUpdateTransaction=(orderid,status,setSelectionModel,page,perPage)=>{
   console.log(status)
  editTransaction(orderid,status,page,perPage).then((response)=>{
  
    const order=response.data.order;
  
    const updated = storeTransactions.map((tranx)=>tranx._id ===order._id ? order :tranx)
    setStoreTransactions(updated)//set transaction data  with new updated one 
    //setSelectionModel([]);
    
  });
}

const editTransaction =(orderid,status,page,perPage)=>{
const url = `${process.env.REACT_APP_SERVER_URL}/orders/${orderid}`;
const user = JSON.parse(localStorage.getItem('user'));

const body={
       status:status,
       storeId:stores[storeindex]._id,
       page:page,
       perPage:perPage
}
const config = {
  headers: {
      'auth-token':
        user.auth_token,
    }
    ,timeout: 15000, withCredentials: true,credentials: "include"
}
return axiosClient.patch(url, body,config)

};

//update many transactions

const handleUpdateManyTransactions= async (option,setSelectionModel,selected_Ids,page,perPage)=>{

  editTransactions(option,selected_Ids,page,perPage).then((response)=>{            
      if(response.status===200){
       setStoreTransactions(response.data.data);
       setSelectionModel([])
      }                 
  
  });
  }
  
  const editTransactions = async (option,selected_Ids,page,perPage)=>{
  const ids=JSON.stringify(selected_Ids);
  const url = `${process.env.REACT_APP_SERVER_URL}/orders/many/byIds/${ids}`;
  const user = JSON.parse(localStorage.getItem('user'));
  const storeId=stores[storeindex]._id
  
  const body={
       storeId:storeId,
       status:option,
       ids: ids,
       page:page,
       perPage:perPage
  }
  const config = {
  headers: {
      'auth-token':
        user.auth_token,
    },timeout: 20000, withCredentials: true,credentials: "include"
  }
  return axiosClient.patch(url, body,config)
  
  };



// Product logic now handled by useProducts hook
// handleLoadUser is now provided by useUser hook
const getUserscopesArrayString=(usercountryscope)=>{

  let scopes =[];

  usercountryscope.forEach(scope=>{
      if (scope.name !== undefined){
        scopes.push(scope.name)
      }

}) 
 return scopes;

}
const handlesearchByCategoryGroups = async (groupid)=>{
        setShowProgress(true)
        
   searchProductByCategoryGroup(groupid).then((response) => {
     setShowProgress(false)
     setIsUserSearching(true)
     scrollToSection('products-section')

   if (response.status===200){
   
     try{
       setFilteredProducts(response.data.products)
       if (response.data.products.length > 0){
       
       }
     /*  if(response.data.products.length > 0) {
        ResetRecentProducts()
        if (history.location !=='/products'){
            history.push('/products')

        }

      }else{
        setShowRecent(true)
      } */
     }catch(err){
       console.log(err)
     }
   }
   //addToast(exampleToast(response.data.message));
 })

}


const searchProductByCategoryGroup =(groupid)=>{
  console.log(groupid)
   const url = `${process.env.REACT_APP_SERVER_URL}/products/category/group/${groupid}`;
   
   return axiosClient.post(url,{usercountryscope:getUserscopesArrayString(usercountryscope)},config)
  
  };

  
const handlesearchByCategory = async (categoryid)=>{
  setShowProgress(true)
searchProductByCategory(categoryid).then((response) => {
setShowProgress(false)
setIsUserSearching(true)
//console.log(response.data);
if (response.status===200){
  setFilteredProducts(response.data.products)

try{
 /* if(response.data.products.length >0) { 
 ResetRecentProducts()

  if (history.location !=='/products'){
      history.push('/products')

  }
}else{
  setShowRecent(true)

} */
}catch(err){
 console.log(err)
}
}
//addToast(exampleToast(response.data.message));
})

}

const searchProductByCategory =(categoryid)=>{

 const url = `${process.env.REACT_APP_SERVER_URL}/products/category/${categoryid}`;
 const scopes=  getUserscopesArrayString(usercountryscope);
 return axiosClient.post(url,{countryscopes:scopes},config)

};
const  hanldeonSearchInputChange =(searchString)=>{
  console.log(searchString)
  if (searchString===''){
    setIsUserSearching(false)
  }
}

const handlesearchProduct = async (searchString)=>{
   console.log(searchString)

   if (searchString !==''){
    setIsUserSearching(true)
    setFilteredProducts([])
    setShowProgress(true)
    
   await searchProduct(searchString).then((response) => {
    setShowProgress(false)
    scrollToSection('products-section')

    console.log(response.data);
    if (response.status===200){
       setFilteredProducts(response.data.products)
               //history.push('/search')
     /*  try{
        
        if(response.data.products.length > 0) {
          ResetRecentProducts()
          if (history.location !=='/products'){
              history.push('/products')
          }
        }else{
          
          setShowRecent(true)

        }
      }catch(err){
        console.log(err)
      } */
    }
    //addToast(exampleToast(response.data.message));

  })}else{
    //history.push('/')
    setShowProgress(false)
    setIsUserSearching(false)

  }  

}




// searchProduct now provided by useProducts hook
const loadMoreRecentProducts =async(prodsPage) => {
 // setShowProgress(true)
 setLoadingMore(true)
      //check if first page loaded or product alredy exist if exist load next page ,This increase before loading because initial products is loaded on page load
        setProdsPage(prev => prodsPage +1 )
       
  try{
      await fetchMoreRecentProducts(prodsPage).then((response)=>{
        setShowProgress(false);
        setLoadingMore(false)
        const products=response.data.products
        setRecentProducts(recentProducts=>[...recentProducts,...products]);
        //setrecentPCount(products.length)
         //console.log(recentPCount+ ' Thats what we have for you today ')
         
        if (products.length < prodsPerpage){ //reurn products not enough meaning that all of the products from server
          setNomoreProducts(!noMoreProducts)
        }
     })
      
     //console.log(tmp);
  }catch(error){

  }
}
const fetchMoreRecentProducts = async (prodsPage)=>{
  try{
     const url =`${process.env.REACT_APP_SERVER_URL}/products/recent/${prodsPage===0 ? 1:prodsPage}/${prodsPerpage}`
    return  await axiosClient.get(url,{},config)
  }catch(error){
    
  }
}
const fetchMoreRecentProductsOrderByScope = useCallback(async (prodsPage,prodsPerpage,usercountryscope)=>{
  try{
    
    let scopes = getUserscopesArrayString(usercountryscope)
    console.log(scopes)
    const url =`${process.env.REACT_APP_SERVER_URL}/products/recent/orderbyscope/${prodsPage}/${prodsPerpage}`
    return  await axiosClient.post(url,{countryscopes:scopes},config)
  }catch(error){

  }
},[])
const loadMoreRecentProductsOrderbyScope =useCallback(async(prodsPage) => {
  setShowProgress(true)
  setLoadingMore(true)
  try{
    if (usercountryscope.length>0){
     await fetchMoreRecentProductsOrderByScope(prodsPage,prodsPerpage,usercountryscope).then((response)=>{

         const products=response.data.products
        setShowProgress(false);
        setLoadingMore(false)
        setRecentProducts(recentProducts=>[...recentProducts,...products]);
          console.log(recentPCount+ ' Thats what we have for you today ')

          if (products.length < prodsPerpage){  
           setNomoreProducts(!noMoreProducts)
          
          }
          
          if(products.length >= prodsPerpage) {//check if first page loaded or prpduct alredy exist if exist load next page
           setProdsPage(prev => prodsPage +1 )
          }
     }) 
    }
     // console.log(tmp);
  }catch(error){

  }
},[fetchMoreRecentProductsOrderByScope, noMoreProducts, prodsPerpage, recentPCount, setNomoreProducts, setProdsPage, setRecentProducts, setShowProgress, usercountryscope])



 //New Products Here
 const onSubmitProduct = (e,clearFields,body,accessToken) =>{
       
    setShowProgress(true)
  /*  var body={
     name:name,
     price:price,
     shippingFees:shippingFees,
     categoryId:categoryId,
     description:description,
     specification:specification,
     digitalProductUrl:digitalProductUrl,
     storeid:storeid,
     stock:stock,
     active:active,
     colors:colors,
     sizes:sizes,
     productImages:productImages,
     productCategory:productCategory
   } */
      product.create(accessToken,body).then((response) => {
        console.log(accessToken)
        setShowProgress(false)
        // console.log(response.data);
        if (response.data.status===200){
         //window.location.reload();
         setStoreProducts(storeProducts=>[...storeProducts,response.data.product])
           clearFields();
          setMessage({body:t("alerts.product_created_successfully"),severity:'success'})
          setOpenSnackBar(true)
          setOpenReviewDialog(true);
        }else if (response.data.status===400){
           
           const msg= CloudTranslatejs(langcode,t,response.data.message)
           if (msg){
            setMessage({body:msg,severity:'error'})
            setOpenSnackBar(true)
           }
          
         /* Alert.error(response.data.message, {
           position: 'top-right',
           effect: 'jelly'

       }); */
      // history.go(0);
        }else if (response.data.status===403 && loggedin === 'true'){
          setMessage({body:t("alerts.tokenexpired") ,severity:'info'})
          setOpenSnackBar(true)
          authenticateToken(user)
        }else if(response.data.status===405){
          const msg= CloudTranslatejs(langcode,t,response.data.message)
          if (msg){
           setMessage({body:msg,severity:'error'})
           setOpenSnackBar(true)
          }
        }
       });
      
 }

 //New Store Here
 const  handleSubmitStore = async(body,clearfields)=>{
  /*console.log(userObj)*/
  setShowProgress(true)
await  dbstore.create(userObj.auth_token,body,clearfields).then((response) => {
    setShowProgress(false)
   //console.log(response.data.store);
   if (response.status===200){
      localStorage.setItem('stores', JSON.stringify(response.data.stores));
     setStores(response.data.stores)
     setMessage({body:t("alerts.storecreated"),severity:'success'})
     setOpenSnackBar(true)
     clearfields();
     //history.push('/account') //return accounta page
     const store=response.data.stores[0]
     handleCreateAccount(user.uid,store._id)
   }else{
    setMessage({body:`${response.data.error}`,severity:'error'})
    setOpenSnackBar(true)
   }
   //addToast(examp leToast(response.data.message));
 }).catch((err)=>{
    console.log(err)  
 })
} 
 const fetchStores = useCallback(async(user)=>{
  try{
    
           const url =`${process.env.REACT_APP_SERVER_URL}/stores/user/${user._id}`;
      
           return  axiosClient.get(url,config);
           
  }catch(error){

  }
},[])
const fetchStoresStatus = async(user)=>{
  try{
    
           const url =`${process.env.REACT_APP_SERVER_URL}/stores/user/${user._id}`;
      
           return  axiosClient.get(url,{},config);
           
  }catch(error){

  }
}
const getStoreStatus = async (storeId)=> {
    await store.get(storeId).then((response)=>{
      if (response.status===200){
        console.log(response.data.storeStatus)
        return response.data.storeStatus


      }
    })
}


const handlegetStores = useCallback( async(user) => {
     //setShowProgress(true)
try{
    await fetchStores(user).then((response)=>{
      //setShowProgress(false)
      if (response.status ===200)
      var Stores = response.data.store;

      setStores(response.data.store); 
       if (response.data.store.length > 0){

        localStorage.setItem('stores',JSON.stringify(response.data.store))
        var daabia =new Daabia(stores[storeindex]._id);
        //history.push('/new-product')
       }
      
    });
 
}catch(error){
    //console.log(error)
}
},[fetchStores, setStores, storeindex, stores]) 
const handlegetStoreAccountBalance =  async () => {//get Orders 
  

  getAccount().then((response)=>{
try{
  setAccount(response.data)
  setBalance(parseFloat(response.data.balance).toFixed(8))

   }catch(err){
   console.log(err)
}
});
}

const getAccount = async ()=>{

try{
  var url = `${process.env.REACT_APP_SERVER_URL}/accounts/${user.uid}/${stores[storeindex]._id}`

 return await axiosClient.get(url,{},config)

}catch(err){
  console.log(err)
}
};

const handlegetAccount  = async (uid,storeId)=>{
  setShowProgress(false)

  if(uid!==undefined && storeId!==undefined){
   
    upDateBalance(uid,storeId).then((response) => {
     // console.log(response.data);
     setShowProgress(false)

      if (response.status===200){
          setAccount(response.data.account)
      }

    })
   }
}
const upDateBalance =(uid,storeId)=>{
  
  const url = `${process.env.REACT_APP_SERVER_URL}/accounts/update`;

  return axiosClient.patch(url,  {
    storeId:storeId,
    uid:uid,
   
  },config)

};

const handleUpdateAccount  = async (uid,storeId,amount)=>{
  setShowProgress(false)

  if(uid!==undefined && storeId!==undefined){
   
    updateBalance(uid,storeId,amount).then((response) => {
     // console.log(response.data);
     setShowProgress(false)

      if (response.status===200){
          setAccount(response.data.account)
      }

    })
   }
}
const updateBalance =(uid,storeId,amount)=>{
  
  const url = `${process.env.REACT_APP_SERVER_URL}/accounts/update`;

  return axiosClient.patch(url,  {
    storeId:storeId,
    uid:uid,
    amount:amount
   
  },config)

};



const handleCreateAccount  = async (uid,storeId)=>{

  if(uid!==undefined && storeId!==undefined){
   
    try {
      createAccount(uid,storeId).then((response) => {
        // console.log(response.data);
        setShowProgress(false)
   
         if (response.status===200){
             setAccount(response.data.account)
             history.push('/account')
         }else{
             history.push('/account')
         }
        
       })
    } catch (error) {
      console.log(error)
    }
   }
}
const createAccount =(uid,storeId)=>{
  
  const url = `${process.env.REACT_APP_SERVER_URL}/accounts/create`;

  return axiosClient.post(url,  {
    storeId:storeId,
    uid:uid,
   
  },config)

};

const handlepostMessage= async(storeid,productId,message,inSilent) =>{

       await postMessage(storeid,productId,message,inSilent).then((response)=>{
        
              setNotification(response.data.message)
             if (!inSilent) setMessage({body:t("alerts.messagesenttostore"),severity:'success'})
       })

}

 const postMessage =(storeId,productId,message) =>{

  const url = `${process.env.REACT_APP_SERVER_URL}/messages`;
   
  return axiosClient.post(url,{
    storeId:storeId,
    productId:productId,
    message:message
  },config)
}


   const getNotification = async(storeid)=>{

     try{
       var url = `${process.env.REACT_APP_SERVER_URL}/messages/bystore/${storeid}`

       return await axiosClient.get(url,{},config)

       }catch(err){
       console.log(err)
      }
};
const handlegetNotification =  useCallback(async(storeid) => {//get Orders 

  console.log(storeid)
 getNotification(storeid).then((response)=>{
try{
 //console.log(response.data)
 var UnReadcount = 0;
 var message =response.data.message
 for(let i=0;i < message.length;i++){
  console.log(message[i].isRead)
   if (message[i].isRead === false){
      UnReadcount=+1;
   }
}
 setNotification({message:message,new_messages_Length:UnReadcount})
 

  }catch(err){
  console.log(err)
}
})},[setNotification])


const handleCreateAppcredits  = async (uid)=>{

  if(uid!==undefined){
   
   await createAppcredits(uid).then((response) => {

      if (response.status===200){
          setAppcredits(response.data.appcredits)

      }

    })
   }
}
const createAppcredits =(uid)=>{
  
  const url = `${process.env.REACT_APP_SERVER_URL}/appcredits/create`;

  return axiosClient.post(url,  {
    uid:uid,
   
  },config)

};
// Handle claim action  
const handleVisitsClaim = async(useruid) => {
  logToGoogleSheet(`handle claim adNetworkSupported : ${isAdNetworkSupported}`)
    showRewardedPiAds(useruid)

  if(isAdNetworkSupported){

  }else{
    //setOpenBrowserUpdatemodal(!openBrowserUpdateModal)
  }
    
}

const updateAppcredits = (points,type)=>{
  setShowAddresses(true)
  const url = `${process.env.REACT_APP_SERVER_URL}/appcredits/update/${user.uid}`;

   axiosClient.patch(url,  
    {type:type,points:points
  },config).then((response)=>{
    console.log(response)
    setShowAddresses(false)
    if (type ==='visits'){ 
    /*  const pref = preference("true","true",false)
     //console.log(pref)      
     setVisited(pref.visited)
     setClaimedReward(pref.claimed)
     setOpenmedalmodal(true)
      ; */}
    setAppcredits(response.data.appCredits)
    
  })

};

 


const getAppcredits = useCallback( async(useruid)=>{

try{
  var url = `${process.env.REACT_APP_SERVER_URL}/appcredits/${useruid}`

 return await axiosClient.get(url,{},config)

}catch(err){
  console.log(err)
}
},[]);
const handlegetAppcredits =  useCallback((useruid) => {//get Orders 


  getAppcredits(useruid).then((response)=>{
try{
  console.log(response.data)
  setAppcredits(response.data.appcredits)

   }catch(err){
   console.log(err)
}
});
},[getAppcredits, setAppcredits])


const handleUnprocessedOrders = async ()=>{
  
  getUnprocessedOrders().then((response)=>{//returns cart items containing unporcessed orders rturn emoty cart object 
    try{
      if (response.data.status===200){
      
        if (response.data.cart.length >0) 
        setCart(response.data.cart)
          setItemsCount(response.data.cart.items.length);
        setMessage({body:t("alerts.found_unprocessed_orders"),severity:'info'})
        setOpenSnackBar(true)
         
         }

     }catch(err){
       console.log(err)
    }
 })
  
}
const getUnprocessedOrders =()=>{

  const url = `${process.env.REACT_APP_SERVER_URL}/orders/user/unprocessed/${userid}`;
  
  return axiosClient.get(url,{},config)

}
   const fetchRecentProductsOrderbyscope = useCallback(async (limit,usercountryscope)=>{
    try{
         console.log(usercountryscope)
      const url =`${process.env.REACT_APP_SERVER_URL}/products/recent/orderbyscope/${prodsPage}/${prodsPerpage}`
      return  await axiosClient.post(url,{countryscopes:usercountryscope},config) //{scopes:'Ghana'}
      
    }catch(error){
  
    }
  },[prodsPage, prodsPerpage])

   const getRecentProductsByscope =useCallback(async(limit,countryscope) => {
  //setUsercountryscope(scopes)
  try{if(countryscope.length >0 ){
    
    await fetchRecentProductsOrderbyscope(limit,countryscope).then((response)=>{
      setShowProgress(false)
      console.log(response.data.products);
      
      setRecentProducts(response.data.products);

      })
  }else{
   
  }
    
  }catch(error){

  }
},[fetchRecentProductsOrderbyscope, setRecentProducts, setShowProgress])
 useEffect(()=>{
  const browser = detect();
  
  // handle the case where we don't detect detect-browserthe browser
  if (browser){
    setBrowser(browser)
    //console.log(browser.name);
  /* if(browser.name!=='chromium-webview'){
    setOpenBrowsermodal(true)
  }else{
    setOpenBrowsermodal(false)
  } */
  }

  setLoggedin(localStorage.getItem('loggedin') ? localStorage.getItem('loggedin'):'false')
   

   try{
  if (loggedin ==='true'){
    if (stores!==undefined && stores.length > 0){
      if(window.daabia_storeid===undefined){
    //console.log(stores[0]._id)

        var daabia =new Daabia(stores[storeindex]._id);
        //daabia.fetchProducts() 
         //console.log(stores)
       // console.log(stores[storeindex]._id)
     }
    }
    const privacyterms= JSON.parse(localStorage.getItem('privacyterms'))
     if (privacyterms && loggedin){
         if (!privacyterms.privacy && !privacyterms.terms){
            setOpenprivacymodal(true)
         }
     }
  
  }

   }catch(err){
    console.log(err)
   }
 
 },[loggedin, setLoggedin, setOpenprivacymodal, storeindex, stores])

   useEffect(() => {


   if(!isSessionVersionSet){
     setTimeout(()=>{
      if (sessionVersion !== 'v1') {
        handleLogOut()
      localStorage.setItem('sessionVersion', sessionVersion || 'v1');
      window.location.reload();
    }
    },5000)

   }
   /*  const handlePopState = () => {
      handleBlur();
  };

  window.addEventListener('popstate', handlePopState);
 */
 
   const langcode = localStorage.getItem('userLanguageChoice')

      if (langcode)  {
          i18n.changeLanguage(langcode);
         setLangCode(langcode)
      }



    
    if (!user){
      try{
        setUserid(createTempUserId())
         //console.log(JSON.parse(localStorage.getItem('user')))
         setUserObj(JSON.parse(localStorage.getItem('user')))
         setUser(userObj.user!==null ?userObj.user :'');
        //setUser(JSON.parse(localStorage.getItem('user')));
        if (JSON.parse(localStorage.getItem('stores'))!== null){
           setStores(JSON.parse(localStorage.getItem('stores')))
        }  /**/
        setEmailVerified(JSON.parse(localStorage.getItem('confirmed')))

      }catch(err){
       
      }
    }
   
    try{
      if (!history.location.pathname.includes('dashboard')){
      if (user){
       const addrss = user.addresses;
       if (user!==null){
          if (addrss){
            
         setShowAddresses(addrss.length >0 ? true :false)
         setAddresses(addrss.length>0 ? addrss:[])
          }
        }
        console.log(isAuthenticated)
        if(!isAuthenticated){
         authenticateToken(user)

         } 
      }
      }
    }catch(err){
      console.log(err)
    }
  /*  try{
     
    ref.current.ownerDocument.body.scrollTop = 0;
    
   }catch(err){
    console.log(err)
   }
 */
       //get user store balance
  
    
    const fetchRecentProducts = async (prodsPage,prodsPerpage)=>{
      console.log()
      try{
        // 0 is set to always load first page skipping initial 
        const url =`${process.env.REACT_APP_SERVER_URL}/products/recent/${0}/${prodsPerpage}`
        return  await axiosClient.get(url,{},config)
      }catch(error){
  
      }
  }
   

  
  const getFavorites =async() => {
    

    await fetchFavorites().then((response)=>{
       try{
         if (response.status===200){
          
            if (response.status===200){
              //console.log(response.data)
              let d=response.data.favoritesProducts;
              let favs =[];
             for(let i=0;i<d.length;i++){
               favs.push(d[i].productId);
               
             }
          setFavorites(favs);
            }
         }

       }catch(err){
          console.log(err)
       }
    })
   
  }
    const fetchFavorites = async ()=>{
      try{

        const user =  JSON.parse(localStorage.getItem('user')).user
       if (user.email){

      const url=`${process.env.REACT_APP_SERVER_URL}/productlikes/${user.email}`
        return axiosClient.get(url,{},config);
       }

      }catch(error){
  
      }
  }

  const handlegetgetRecommendedProducts = async ()=>{
  
     try{
      getRecommended().then((response) => {
        if (response.status===200){
         
          setRecommededproducts(response.data.products)
          
        }
      })
    }catch(err){
            console.log(err)
          }
    
  }
  
    const getRecommended =()=>{
       
        
        const url = `${process.env.REACT_APP_SERVER_URL}/products/recommended`;
        
        return axiosClient.post(url,{/* ids:JSON.stringify(productdIds) */},config)
      
    
    };
    

    const handlegetgetPopularProducts = async ()=>{
  
      try{
        getPopular().then((response) => {
         if (response.status===200){
          
           setPopularproducts(response.data.products)
           
         }
       })
     }catch(err){
             console.log(err)
           }
     
   }
   
     const getPopular =()=>{
        
         
         const url = `${process.env.REACT_APP_SERVER_URL}/products/popularproducts`;
         
         return axiosClient.post(url,{/* ids:JSON.stringify(productdIds) */},config)
       
     
     };
    
     
     const handlegetgetBestSellers = async ()=>{
  
      try{
        getBestSellers().then((response) => {
         if (response.status===200){
          
           setBestSellers(response.data.bestsellers)
           
         }
       })
     }catch(err){
             console.log(err)
           }
     
   }
   
     const getBestSellers =()=>{
        
         
         const url = `${process.env.REACT_APP_SERVER_URL}/products/bestsellers/products`;
         
         return axiosClient.get(url,{/* ids:JSON.stringify(productdIds) */},config)
       
     
     };
    
     
  const getRecentProducts =async(prodsPage,prodsPerpage,recentProducts) => {
    try{
       console.log(usercountryscope)
       await fetchRecentProducts(prodsPage,prodsPerpage).then((response)=>{
          console.log(response.data.products); 
         setRecentProducts(response.data.products);
      
       })
      
    }catch(error){
  
    }
  }
 const fetchProducts = async ()=>{
      try{
         
         const url =`${process.env.REACT_APP_SERVER_URL}/products`
         return  await axiosClient.get(url,{},config)
         
      }catch(error){
  
      }
  }
  const getProducts =async() => {
    try{
        await fetchProducts().then((response)=>{
        setProducts(response.data.products);
       })
      /*  let tmp =[];
          for(let i=0;i<productsFromServer.length;i++){
            tmp.push(productsFromServer[i]);
            
          }
       setProducts(tmp); */
       //console.log(tmp);
    }catch(error){
  
    }
  } 

  
  const handlegetCart = async (userid)=>{
  // console.log("get cart "+ userid)
   try{
    getCart(userid).then((response) => {
      
      if (response.status===200){
       
          setCart(response.data.cart)
          const cart = response.data.cart
          if (cart.items!==undefined)
          setItemsCount(response.data.cart.items.length);
        
      }
      //addToast(exampleToast(response.data.message));
    })
  }catch(err){
          console.log(err)
        }
  
}

  const getCart =(userid)=>{
      if (userid){
        const  options={
          headers:{
            Authorization:`Bearer ${accessToken}`
          },timeout: 20000, withCredentials: true,credentials: "include"
        }
      const url = `${process.env.REACT_APP_SERVER_URL}/carts/${userid}`;
      
      return axiosClient.get(url,{},config)
    
      }
  };
  const filterOrders= (orders/* ,status */)=>{
    try{
      let count = 0;
      for(let i=0;i < orders.length;i++){
      // console.log(orders[i].status.title)
      if(orders[i].status!==undefined){
        if( orders[i].status.title==="Recieved" ||  orders[i].status.title==="Shipped"  ||  orders[i].status.title==="Paid"){
               console.log(i)
               count=count+1
          }

      }
          
      }
        console.log('order counts ' + count)
      setMyOrderCount(count)

    }catch(error){
      console.log(error)
    }
}
  const handlegetOrders = async (userid)=>{
   console.log("get user orders "+userid)
    
    getOrders(userid).then((response)=>{
      try{
        if (response.status===200){
          setMyOrders(response.data.orders)
         
        }

      }catch(err){
         console.log(err)
      }
   })
    
  }
  const getOrders =(userid)=>{

    const url = `${process.env.REACT_APP_SERVER_URL}/orders/user/${userid}`;
    
    return axiosClient.get(url,{},config)
  
  }

  

  const getCategorygroups =async ()=>{

    const url = `${process.env.REACT_APP_SERVER_URL}/category/group`;
    
    return axiosClient.get(url,{},config).then((response)=>{
       try{
         if (response.status===200){
           setgroupCategories(response.data)
         }

       }catch(err){
          console.log(err)
       }
    })
  } 

  
  const getCategories= async()=>{
    
    const url = `${process.env.REACT_APP_SERVER_URL}/category`;
    
    return axiosClient.get(url,{},config).then((response)=>{
       try{
         if (response.status===200){
           setCategories(response.data)
          setProductCategories(response.data)
         }

       }catch(err){
          console.log(err)
       }
    })
  } 
  const loadSlides =async ()=>{
    try{
     const url =`${process.env.REACT_APP_SERVER_URL}/slides/` 
          await axiosClient.get(url,config).then((response)=>{
           //console.log(response.data.slides);
           const slides = response.data.slides
          setSlidesImages(slides[0].image)

     })
    }catch(err){
      console.log(err)
    }
   }

   function loadUserCountryScopes(){
    
    const usercountryscope = JSON.parse(localStorage.getItem('userCountryscope')
    )
      if (usercountryscope && usercountryscope[0].name !== undefined){

      /*   for(let i=0;i<usercountryscope.length;i++){
          userCscopes.push({
            name:usercountryscope[i].name,
            countryCode:usercountryscope[i].iso2
       })    
      } */
  
         setUsercountryscope(usercountryscope)
         /* if (userCscopes.length >0 && !recentProducts) getRecentProductsByscope(limit,userCscopes) */
      }else{
        setUsercountryscope([])
      }
    
   }


   const handlegetLinks = async ()=>{
    const url=`${process.env.REACT_APP_SERVER_URL}/socialmedialinks`

    await axiosClient.get(url).then((response)=>{
      
       // setMedialinks(response.data.socialmedialinks[0].medialinks);
      try{
          const medialinksObj={
            facebook:response.data.socialmedialinks[0].medialinks[0].linktext,
            twitter:response.data.socialmedialinks[0].medialinks[1].linktext,
            instagram:response.data.socialmedialinks[0].medialinks[2].linktext,
            telegram:response.data.socialmedialinks[0].medialinks[3].linktext,
            whatsapp:response.data.socialmedialinks[0].medialinks[4].linktext,
             
          }
          setMedialinks(medialinksObj)
/*         setFaceBook(response.data.socialmedialinks[0].medialinks[0].linktext)
        setTwitter(response.data.socialmedialinks[0].medialinks[1].linktext)
        setInstagram(response.data.socialmedialinks[0].medialinks[2].linktext)
        setTelegram(response.data.socialmedialinks[0].medialinks[3].linktext)
        setWhatsApp(response.data.socialmedialinks[0].medialinks[4].linktext) */

        //getObjectbyValue(response.data.socialmedialinks,'Twitter')
      }catch(err){
          console.log(err)
      }
    })
}

   if(!isStoreBalanceLoaded){
      handlegetStoreAccountBalance()

    }
   
    if (!isUserCountryLoaded){
      loadUserCountryScopes()
    }
   if (!isSlidesLoaded){
    
     loadSlides() 
    
     
   //  handlegetgetRecommendedProducts()
     //handlegetgetPopularProducts()
     //handlegetgetBestSellers()
   
   }
   if (!isLinksLoaded){
    handlegetLinks()
   }
    if (!history.location.pathname.includes('dashboard')){//only load at client side 

      if (!isCategoryGroupLoaded){
          getCategorygroups()
      }
    
     if (!isCategoryLoaded){
      getCategories()
     }
   /*  if(!isProductsLoaded){
      getProducts();
    } */

    const userCountryeScope = JSON.parse(localStorage.getItem('userCountryscope'))
   
    if(userCountryeScope && !loading){
       //console.log(JSON.parse(localStorage.getItem('userCountryscope')))
    if (!isRecentProductsLoaded && userCountryeScope && !loading){
            console.log(userCountryeScope)
      if ( userCountryeScope.length > 0 && userCountryeScope[0]==='All'){
          console.log('loading all ')
        getRecentProducts(prodsPage,prodsPerpage,recentProducts)
      }else{
        console.log('loading only scope')
        loadMoreRecentProductsOrderbyScope(0)
      }
     }
    }
  
    if (!userCountryeScope && !isRecentProductsLoaded && !loading){
     // console.log('loading all ')
      //prompt user to select country
        setOpenCountrySelect(true)
      //getRecentProducts(prodsPage,prodsPerpage,recentProducts)
    }
   

    if (user){     
      if (!isCartsLoaded){
        handlegetCart(user._id);
        handlegetAppcredits(user.uid);
         handlegetOrders(user._id);

      }
    }
     if (user){
             if (!isOrdersLoaded){
         handlegetOrders(user._id);
     
       if (!user.accept_privacy_policy){
        setOpenprivacymodal(true)
      }
     }
     
     } 

     if (user){
      if (!isStoresLoaded && user.merchantId!==undefined){

     // handlegetStores(user)
     }
     
    }
    // if (user ){
      /* if (orderCount<=-1){
        if (myOrders) filterOrders(myOrders)
        
       } */
    // }

   if (stores && stores.length >0){
     if (!isNotificationsLoaded){
      handlegetNotification(stores[0]._id)
     }
   }
    
      if (!isFavoritesLoaded){
       // getFavorites() 
       }
         if (!iscompletePayment) {
           checkInCompletePayments();
           
          }
          if (!isA2ucompletePayment){
           /*  checkA2uInCompletePayments() */
          }

    }
    
    return ()=>{
/*       window.removeEventListener('popstate', handlePopState);
 */
        setIsProductsLoaded(true)
      //if (categories){
        setIsCategoryLoaded(true)
      //}
     
      //if(groupCategories){
         setIsCategoryGroupLoaded(true)
     // }
     // if (products){
         setIsProductsLoaded(true)
      //}
    // if (!loading){
       setIsRecentProductsLoaded(true)
   // }
     setIsLinksLoaded(true)
     setIsSessionVersionSet(true)
     if (cart){
      setIsCartsLoaded(true)
     } 
    if (myOrders){
      setIsOrdersLoaded(true)
   }
    ///console.log(slidesImages)
   // if (slidesImages){
      setIsSlidesLoaded(true)
  //  }
   // if (usercountryscope){
      setisUserCountryLoaded(true)
   // }
      
      if (tempUserToken!==''){
        setIstempTokenLoaded(true)
      }
     if (userObj) {
     // setIsUserObjSet(true)  
     }
      if (user !== undefined){
        setIsFavoritesLoaded(true)
      }
     if (user !== undefined){
      setIsStoreBalanceLoaded(true)
     }
    
     if (user !== undefined){
      setisIncompletePayment(true)
     }
     
     if (user !== undefined){
      setisA2uIncompletePayment(true)
     }
      if(user){
    /*  if (orderCount >=0){
      setIsOrdersCountset(true)
     } */
      }
      if (user){
        try{
          if(user.merchantId!==undefined &&  stores.length >=1){
            setIsStoresLoaded(true)
           }
        }catch(err){
         // console.log(err)
        }
      }
      if(user){
        setIsAuthenticated(true)
       setIsNotificationsLoaded(true)

      }

      if(notification && notification.message){
      }

      //https://sandbox.minepi.com/mobile-app-ui/app/daabia

    }
   },[userid, user, history, isSlidesLoaded, limit, usercountryscope, userObj, istempTokenLoaded, isUserObjSet, isCategoryGroupLoaded, isCategoryLoaded, isProductsLoaded, isRecentProductsLoaded, isCartsLoaded, isOrdersLoaded, isFavoritesLoaded, stores, storeindex, cart, myOrders, isStoreBalanceLoaded, handlegetAppcredits, handlegetStores, isAuthenticated, loadMoreRecentProductsOrderbyScope, i18n, getRecentProductsByscope, products, recentProducts, tempUserToken, isUserCountryLoaded, isLinksLoaded, handlegetNotification, notification, prodsPage, prodsPerpage, checkInCompletePayments, checkA2uInCompletePayments, setAddresses, setBestSellers, setCart, setIsCartsLoaded, setIsCategoryGroupLoaded, setIsCategoryLoaded, setIsFavoritesLoaded, setIsLinksLoaded, setIsOrdersLoaded, setIsProductsLoaded, setIsRecentProductsLoaded, setIsSlidesLoaded, setIsStoreBalanceLoaded, setIstempTokenLoaded, setItemsCount, setOpenprivacymodal, setPopularproducts, setProducts, setRecentProducts, setRecommededproducts, setShowAddresses, setStores, setTempUserToken, setUser, setUserObj, setisUserCountryLoaded, categories, groupCategories, slidesImages, openCountrySelect, orderCount, isNotificationsLoaded, accessToken, setUserid, iscompletePayment, isA2ucompletePayment, isStoresLoaded, setUsercountryscope, loading, authenticateToken, setIsAuthenticated, isSessionVersionSet, sessionVersion, setFavorites, setIsSessionVersionSet, handleLogOut])
   
   

  
    if (loading) {
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <CircularProgress />
        </Box>
      );
    }

  return (
    <ThemeProvider theme={theme}>
    
    <Box sx={{ pb: 0 ,border:0,height:'100vh',backgroundColor:'#f3e6f9'}} ref={ref}  >

          <AlertDialog dialogRef={ref} open={openReviewDialog} title={t('dialog.pendingReview.title')} textContent={t('dialog.pendingReview.message')} handleClose={() => {setOpenReviewDialog(false)}} positiveButtonText={t('dialog.button.ok')} />
     <Grid container justifyContent={'space-between'} >
        
        <Grid item xs={12} sm={12} md={10} lg={12} border={0}>  
         {/*  <PiPrice apiKey='c55683aaf175c34805747c9c48c6bce012803ab093a5064171814184b0632903' from='GHS' to='Pi' amount={13}/>
        Start of modals and alerts componets */}

            
        { showprogress ?  <div className='circularProgress-wrapper'>
         <CircularProgress  variant='indeterminate' color ='primary' size={29} />
        </div>:''} 

         
        {
             showNotification && notification.message && notification.message.length > 0 ?   <Notification notification={notification} showNotification={showNotification} setShowNotification={setShowNotification} t={t} langcode={langcode} axiosClient={axiosClient} config={config}/> :''
          }
         
           <TopbarcontacInfo/>
             <CssBaseline />
           {groupCategories && productCategories ? <NestedList showCategory={showCategory} setShowCategory={setShowCategory} groupCategories={groupCategories} categories={productCategories} handlesearchByCategoryGroups={handlesearchByCategoryGroups} handlesearchByCategory={handlesearchByCategory} setIsUserSearching={setIsUserSearching}/>:''}

            
          
                  
               <UpdateBrowserModal openBrowserUpdatemodal={openBrowserUpdateModal}setOpenBrowserUpdatemodal={setOpenBrowserUpdatemodal} t={t}/>
                    <LoginModal openModal={openLoginModal} handleCloseModal={handleCloseModal} setStores={setStores} user={user} setUser={setUser} ref={ref} signIn={signIn} showprogress={showprogress}/>
                {  deviceType !== 'mobile' ?<AccountPanel showprofile={showprofile}setShowProfile={setShowProfile} />: ""}
                    <AlertDialog open={openBrowserModal} title={''} textContent={t("notice.browsertypenotice",{browsername:browser.name,websitename:process.env.REACT_APP_WEBSITE_NAME})} handleClose={handleCloseBrowserModal} positiveButtonText={t("dialog.button.yes")} negativeButtonText={t("dialog.button.cancel")}/>

                <Medalalerts open={openMedalModal} handleClose={handleCloseMedalModal} t={t} />

                {user && openPrivacyModal ?  <Grid container justifyContent='space-between'>
                  <Grid item sx={12} sm={12} md={6} lg={6}>
                  <Policyterms acceptpolicy={user.accept_privacy_policy} termsofService={user.accept_terms_of_service} open={openPrivacyModal} privacyAction={privacyAction}/>
                  </Grid>
                </Grid>:''}
                 {/* Start of modals and alerts componets */}
              
              {/* Start of Home Route */}
              <Route exact path="/"> 
               <Suspense fallback={<TopBarFallback/>}>

    
              <Topbar totalItems={itemsCount} totalOrders={orderCount} setIsUserSearching={setIsUserSearching}
          handlesearchProduct={handlesearchProduct}hanldeonSearchInputChange={hanldeonSearchInputChange} handleUserClick={handleUserClick}  showCategory={showCategory} setShowCategory={setShowCategory} setLangCode={setLangCode}langcode={langcode}
          showprofile={showprofile}setShowProfile={setShowProfile}  handleFocus={handleFocus}
          handleBlur={handleBlur}  prodsPerpage={prodsPerpage} setProdsPerpage={setProdsPerpage} getRecentProductsByscope={getRecentProductsByscope}  openCountrySelect={openCountrySelect} setNomoreProducts={setNomoreProducts} setOpenCountrySelect={setOpenCountrySelect} usercountryscope={usercountryscope} setUsercountryscope={setUsercountryscope} t={t} groupCategories={groupCategories}
          />  
      </Suspense>
      


          <CountryScopeSelector prodsPerpage={prodsPerpage} setProdsPerpage={setProdsPerpage} getRecentProductsByscope={getRecentProductsByscope} setUsercountryscope={setUsercountryscope} setNomoreProducts={setNomoreProducts} noMoreProducts={noMoreProducts} usercountryscope={usercountryscope} t={t} openCountrySelect={openCountrySelect} setOpenCountrySelect={setOpenCountrySelect} handleFocus={handleFocus} handleBlur={handleBlur} ref={ref}/>

    { /* groupCategories ? <GroupFloor groupCategories={groupCategories}  handlesearchByCategoryGroups={handlesearchByCategoryGroups}  setShowProgress={setShowProgress} setIsUserSearching={setIsUserSearching} getRecentProductsByscope={getRecentProductsByscope} 
    
    /> :'' */}
     <Grid container>

      
          <Grid item xs={0} sm={0} md={0} lg={1}>

          </Grid>
          <Grid item  xs={12} sm={12} md={12} lg={10} >
          
        <Box  className={classes.content} sx={{ paddingLeft:'16px',
     paddingRight:'16px',}} >  
        <Herosection user={user} stores={stores} slidesImages={slidesImages}/> 
       
        {
          
          <Grid container justifyContent='center' alignItems={'center'} spacing={0.2} border={0} onClick={()=>{setOpenCountrySelect(!openCountrySelect);}}>
         <Grid item alignItems={'center'} justifyContent={'center'} >
           <Grid container>
         { /*    <Grid item onClick={()=>{setOpenCountrySelect(!openCountrySelect);}}>

               <Typography fontSize={'0.8rem'}>{usercountryscope.length >0 ?<>{usercountryscope.map((item,i)=>{
                      return<Grid item key={`key-${i}`}> <ReactCountryFlag onClick={()=>{setOpenCountrySelect(!openCountrySelect);}}  countryCode={item.countryCode ? item.countryCode : item.iso2} svg
                          
                      style={{ width: '1em',
                       height: '1.2em',}}/> </Grid>
                 })  }</>:t("countrychoice.all")}</Typography>               
               </Grid>  
             <Button onClick={()=>{setOpenCountrySelect(!openCountrySelect);}}>Select Country</Button>
               isDesktop? ""  : <Grid item xs={6} md={0} lg={0} onClick={()=>{setOpenCountrySelect(!openCountrySelect);}} >
                 <img src={Globe} width={isDesktop?'40px':'20px'} onClick={()=>{setOpenCountrySelect(!openCountrySelect);}}  height={isDesktop?'40px':'20px'} style={{marginTop:isDesktop?'0px':'3px'}} alt='countryscope' />
                
               </Grid> */
               
               }
           </Grid>
          </Grid>
        </Grid>
        }
               
        
       
        
        <Grid container justifyContent={'space-between'}  xs={{backgroundColor:'var(--app-secondary-light)'}}  paddingLeft={2} paddingRight={2} border={0}>
        
        <Grid item sx={0} sm={12} md={12} lg={6} border={0}>
          
        { popularProducts.length > 0 ? <Box sx={{width:'100%',height:'auto',paddingTop:2,justifyContent:'flex-start',}}  lg={{width:'100%',height:'auto',paddingTop:2,paddingLeft:13,paddingRight:13,justifyContent:'flex-start',}} >

        {/* <Typography variant='h6' color='GrayText'>{t('homepage.popularproducts')} </Typography>


       <PopularProducts products={popularProducts} onAddToCart={handleAddtoCart} onUpdateLikes={handleUpdateLikes} favorites={favorites} setOpenModal={setOpenModal} loadMore={loadMore} LoadingMore={LoadingMore} setLoadMore={setLoadingMore} noMoreProducts={noMoreProducts} showAds={false}  /* setIsproductLoaded={setIsproductLoaded} setIsCommentsLoaded={setIsCommentsLoaded} setIsStoreLoaded={setIsStoreLoaded} setStoreId={setStoreId} setProductId={setProductId} setShowProgress={setShowProgress} setStore={setStore} />  */}

         </Box>   :''} 
        {/*  recommendedProducts.length > 0 ? <Box  sx={{p:1,width:'100%',height:'20vh'}} >
              <Grid container padding={1}>
         <Grid item>
         <Typography variant='body2' color='GrayText'>{t('homepage.recommended')} </Typography>
         </Grid>
       </Grid>

       <RecommendedProducts products={recommendedProducts} onAddToCart={handleAddtoCart} onUpdateLikes={handleUpdateLikes} favorites={favorites} setOpenModal={setOpenModal} loadMore={loadMore} LoadingMore={LoadingMore} setLoadMore={setLoadingMore} noMoreProducts={noMoreProducts} showAds={false}  /* setIsproductLoaded={setIsproductLoaded} setIsCommentsLoaded={setIsCommentsLoaded} setIsStoreLoaded={setIsStoreLoaded} setStoreId={setStoreId} setProductId={setProductId}  setShowProgress={setShowProgress} setStore={setStore} /> 

         </Box>   :'' */} 
        {/* <AdsTerraNative adkey='4bc83656577a327298971c0f5e486ead'/>  */}

        </Grid>
        <Grid item  sx={{display: { xs: "none", lg: "block",backgroundColor:'var(--app-secondary-light)'} }} xs={12} sm={12} md={0} lg={6} border={0} padding={0} >
          <Box  sx={{width:'100%',height:'auto',paddingTop:2,justifyContent:'flex-start',border:'0px solid'}} >
            {/*   <Typography variant='h6' color='GrayText'>{t('homepage.bestsellers')} </Typography>

           bestSellers.length >0?<BestSellers bestSellers={bestSellers}/>:'' */} 

       </Box>
        {/* groupCategories ? <GroupCategories setShowCategory={setShowCategory} Categories={groupCategories} categories={productCategories} handlesearchByCategoryGroups={handlesearchByCategoryGroups} setIsUserSearching={setIsUserSearching}/>:'' */}
        </Grid>


        </Grid>
       {/*
        <AdsTerra adkey='3116877d28043bea928e70e45dcf0db6' height={250} width={300}/>
       
      
   { showAds ? <AdBanner src={adsImages[0]} variant='quiz'link={hoplinks[0]}/>
:''} */}  
        {/*  medialinks ?  <Medialinks medialinks={medialinks} />:'' */}
        <Grid container alignItems={'center'} justifyContent={'center'} style={{backgroundColor:'var(--app-font-info)',marginBottom:5}}>
    <Grid item xs={12} >
                 
               </Grid>
    </Grid>
     { /* 
     <Container id='categories' sx={{display:{xs:'none',md:'block'}}}>
     {
      groupCategories &&  groupCategories.length > 0 ? <ImagedCategories  groupCategories={groupCategories} productCategories={productCategories} handlesearchByCategoryGroups={handlesearchByCategoryGroups} handlesearchByCategory={handlesearchByCategory}/>:''
     }
     </Container>
      */
     }
        <>
        
         {showRecent && recentProducts && recentProducts.length > 0 ? 
       <> 
       <Typography variant='body1' className='recents-products-title'></Typography>
       
        <Grid container   direction='column' >
            
            <Grid item >
            <section id='products-section'>
            {!isUserSearching  ? <Suspense fallback={<ProductsGridFallback />}> <Products products={recentProducts}  onAddToCart={handleAddtoCart} onUpdateLikes={handleUpdateLikes} favorites={favorites} setOpenModal={setOpenModal} loadMore={loadMore} LoadingMore={LoadingMore} setLoadMore={setLoadingMore} noMoreProducts={noMoreProducts} showAds={showAds} page="home" limit={limit} setLimit={setLimit}  setrecentPCount={setrecentPCount} addedLimit={addedLimit} prodsPerpage={prodsPerpage} onBottomNavChange={ handleOnBottomNavChange}  totalItems={itemsCount} orderItems={orderCount} stores={stores} /></Suspense>: <> {
             filteredProducts && !showprogress ? <Search products={filteredProducts}  onAddToCart={handleAddtoCart} onUpdateLikes={handleUpdateLikes} favorites={favorites} setOpenModal={setOpenModal} setIsUserSearching={setIsUserSearching} showAds={showAds} t={t} addedLimit={addedLimit} prodsPerpage={prodsPerpage}/> :''
            } </> } </section>
            </Grid>
     
            {/* <Grid item margin={4}> 
         {
         recentProducts &&  recentProducts.length >= prodsPerpage ?  <Grid container justifyContent='center' alignItems='center'>
           {
             !isUserSearching ?  <Grid item>
              
            { !noMoreProducts  ? <></>:<>
            <Typography variant='body2' fontSize='0.7rem' className='recents-products-title' >{t("response.nomoreproducts")} </Typography>
         {  medialinks ?  <Medialinks medialinks={medialinks} />:''}
            </> }
            </Grid> :''
           }
         </Grid>:''
         }
          
         </Grid> */} 
        </Grid>
       </>: <>{!showprogress ? <EmptyProducts t={t}         loadMoreRecentProductsOrderbyScope={loadMoreRecentProductsOrderbyScope}
/>:''}</>}
          
       
        </>
        
        </Box>

     </Grid>
            <Grid item xs={0} sm={0} md={0} lg={1}>
          </Grid>
          
          </Grid>

      
       </Route> 
              {/* End of Home Route */}

              {/* start of products Route */}

              <Route exact path="/products">  
      <Box  className={classes.hoome}>

    { /*   {filteredProducts.length > 0 ? '':<CategoryWidget groupCategories={groupCategories} handlesearchByCategoryGroups={handlesearchByCategoryGroups}/> } */}
     {!isUserSearching ? <Suspense fallback={<ProductsGridFallback />}>
      <Products products={filteredProducts}  onAddToCart={handleAddtoCart} onUpdateLikes={handleUpdateLikes} favorites={favorites} setOpenModal={setOpenModal} loadMore={loadMore} LoadingMore={LoadingMore} setLoadMore={setLoadingMore} noMoreProducts={noMoreProducts} setrecentPCount={setrecentPCount} addedLimit={addedLimit} showAds={false} page="home" t={t} prodsPerpage={prodsPerpage}/>
     </Suspense>: 
     <Search  results={filteredProducts}  onAddToCart={handleAddtoCart} onUpdateLikes={handleUpdateLikes} favorites={favorites} setOpenModal={setOpenModal} loadMore={loadMore} LoadingMore={LoadingMore} setLoadMore={setLoadingMore} noMoreProducts={noMoreProducts} setrecentPCount={setrecentPCount}showAds={false} page="home" t={t} addedLimit={addedLimit} prodsPerpage={prodsPerpage}/>
      }
    </Box>
    
      </Route>

     {/* Start Search */}
     <Route exact path="/search">  

            <Box  className={classes.home}>
            <Topbar totalItems={itemsCount} totalOrders={orderCount} setIsUserSearching={setIsUserSearching}
            handlesearchProduct={handlesearchProduct}hanldeonSearchInputChange={hanldeonSearchInputChange} handleUserClick={handleUserClick}  showCategory={showCategory} setShowCategory={setShowCategory} setLangCode={setLangCode}langcode={langcode} prodsPerpage={prodsPerpage} setProdsPerpage={setProdsPerpage} getRecentProductsByscope={getRecentProductsByscope} setUsercountryscope={setUsercountryscope}setNomoreProducts={setNomoreProducts} handleBlur={handleBlur} openCountrySelect={openCountrySelect} setOpenCountrySelect={setOpenCountrySelect} noMoreProducts={noMoreProducts} usercountryscope={usercountryscope} t={t} groupCategories={groupCategories}
            />
                
            <Search products={filteredProducts}  onAddToCart={handleAddtoCart} onUpdateLikes={handleUpdateLikes} favorites={favorites} setOpenModal={setOpenModal} t={t} setrecentPCount={setrecentPCount}/> 
            </Box>
        </Route>

        
     
      <Route exact path="/store">  
      <Box  className={classes.home}>
        <Store onAddToCart={handleAddtoCart} onUpdateLikes={handleUpdateLikes} favorites={favorites} loadMore={loadMore} LoadingMore={LoadingMore} setLoadMore={setLoadingMore} noMoreProducts={noMoreProducts} t={t}/>
      </Box>
      </Route>

      <Route exact path="/s/:tag">  
     {/* to do  https://stackoverflow.com/questions/42906858/react-router-not-working-with-params */}
        <Store onAddToCart={handleAddtoCart} onUpdateLikes={handleUpdateLikes} favorites={favorites} loadMore={loadMore} LoadingMore={LoadingMore} setLoadMore={setLoadingMore} noMoreProducts={noMoreProducts}/>
      </Route>
     
      <Route exact path="/s/:tag/:productId">  
    
     <ProceedCheckOut onAddToCart={handleAddtoCart}  showAds={showAds}  onUpdateLikes={handleUpdateLikes} favorites={favorites} setOpenModal={setOpenModal} loadMore={loadMore} LoadingMore={LoadingMore} setLoadingMore={setLoadingMore} noMoreProducts={noMoreProducts} setShowProgress={setShowProgress} medialinks={medialinks} adsImages={adsImages} hoplinks={hoplinks} langcode={langcode} browser={browser}/>
      </Route>

     <Route exact path="/new-product/:storeId" >
      {
       /* stores ?   <> */
       /* {stores.length > 0 ?  */<PmNewProduct loggedin={loggedin} setStore={setStore} store ={stores[storeindex]} balance={balance} productCategories={productCategories} onSubmitProduct={onSubmitProduct} setMessage={setMessage} setOpenSnackBar={setOpenSnackBar} accessToken={accessToken} handlegetTransactions={handlegetTransactions} setPage={setPage} page={page} perPage={perPage} setPerPage={setPerPage} handleNavigatePage={handleNavigatePage} handleSignIn={handleSignIn} t={t}/>/* :'' */
     }{/* </>:'' */}
      

      </Route>

      <Route exact path="/new-store">

 { <NewStore setStores={setStores} stores={stores}  handleSubmitStore={handleSubmitStore}  setOpenSnackBar={setOpenSnackBar} setMessage={setMessage} t={t} user={user} setUser={setUser}setUsercountryscope={getRecentProductsByscope}/>}
      </Route> 
      <Route exact path="/my-store">
       {
         stores ? <MyStore mystore={stores[0]} setStore={setStore} balance={balance} setStores={setStores} setMessage={setMessage} setOpenSnackBar={setOpenSnackBar} handleSubmitStore={handleSubmitStore} accessToken={accessToken} t={t} notification={notification} /> :''
       }
      </Route> 
      <Route exact path='/product-list'>
       {stores ? <>  {stores.length > 0 ? <PmProductList  sproducts={storeProducts} balance={balance}handlegetStoreProducts={handlegetStoreProducts} handleDeleteStoreProduct={handleDeleteStoreProduct} isStoreProductsLoaded={isStoreProductsLoaded} handlegetTransactions={handlegetTransactions}setIsStoreProductsLoaded={setIsStoreProductsLoaded} store={stores[storeindex]} theme={theme} isStoreTransLoaded={isStoreTransLoaded}setIsStoreTransLoaded={setIsStoreTransLoaded} page={page} setPage={setPage} perPage={perPage} setPerPage={setPerPage} t={t}/>:''}</>:''}
      </Route>

      <Route exact path='/edit-product'>
         {
           stores ? <>  {stores.length > 0 ? <PmProduct  store={stores[storeindex]} balance={balance} setShowProgress={setShowProgress} showprogress={showprogress}  authenticateToken={authenticateToken} setMessage={setMessage} setOpenSnackBar={setOpenSnackBar}storeProducts={storeProducts} handlegetTransactions={handlegetTransactions} setStoreProducts={setStoreProducts} isStoreTransLoaded={isStoreTransLoaded}setIsStoreTransLoaded={setIsStoreTransLoaded}
           t={t} theme={theme}/>:''}</>:''
         }
      </Route>
     
      <Route exact path='/transactions'>
        {
         stores ? <> {stores.length > 0 ? <Transactions user={user}  store={stores[storeindex]} handlegetTransactions={handlegetTransactions} transactions={storeTransactions} sales={sales} balance={balance} handleUpdateManyTransactions={handleUpdateManyTransactions} handleUpdateTransaction={handleUpdateTransaction} setShowProgress={setShowProgress} showprogress={showprogress}  authenticateToken={authenticateToken} isStoreTransLoaded={isStoreTransLoaded}setIsStoreTransLoaded={setIsStoreTransLoaded} theme={theme} handleRefund={handleRefund}
         page={page} setPage={setPage} perPage={perPage} setPerPage={setPerPage} t={t} translateStatus={translateStatus} setMessage={setMessage} setOpenSnackBar={setOpenSnackBar} setSelectedTransaction={setSelectedTransaction}/>:''}
 </>:''
        }
      </Route>
     <Route exact path='/transactions/details/:transactionId'>
     <Grid container>
                          { user && storeTransactions ? <Details  transactions={storeTransactions}  userid={user._id} user={user}  store={store} order={selectedTransaction} waitonCustomer={waitonCustomer} setSelectedTransaction={setSelectedTransaction} setWaitOnCustomer={setWaitOnCustomer} /* onReviewClick={handleonReviewClick} */ handleUpdateTransaction={handleUpdateTransaction}
                            setMessage={setMessage} setOpenSnackBar={setOpenSnackBar}  t={t} translateStatus={translateStatus} showprogress={showprogress}/> :'... loading'}
                         </Grid>
     </Route>

      <Route exact path='/withdraw'>
       {
         stores ? <>
          {stores.length > 0 ? <Withdraw store={stores[storeindex]} handlegetTransactions={handlegetTransactions} transactions={storeTransactions}  balance={balance} setShowProgress={setShowProgress} showprogress={showprogress}  authenticateToken={authenticateToken} isStoreTransLoaded={isStoreTransLoaded}setIsStoreTransLoaded={setIsStoreTransLoaded} setMessage={setMessage} setOpenSnackBar={setOpenSnackBar} user={user} signIn={signIn} setBalance={setBalance}
handleSendConfirmationCode={handleSendConfirmationCode} handleConfirmedUser={handleConfirmedUser} setEmailVerified={setEmailVerified} page={page} perPage={perPage} t={t}/>:''}
         </>:''
       }

      </Route>
      <Route exact path="/cart">    
      <Box className={classes.content}> 
       {cart  ?
          <Cart cart={cart} user={user} loggedin={loggedin} handleUpdateCartQty={handleUpdateCartQty} handleupdateColorSize={handleupdateColorSize} handleupdateMeasurement={()=>{}} handleRemoveFromCart={handleRemoveFromCart}
         handleEmptyCart={emptyCart} handleupdateSelection={handleupdateSelection} updateCartItems={updateCartItems} authenticateToken={authenticateToken} setOpenModal={setOpenModal} handleUnprocessedOrders={handleUnprocessedOrders} t={t} langcode={langcode} 
         handleFocus={handleFocus}
         handleBlur={handleBlur}
         /> :''
       }
       
       </Box>
      </Route>
      <Route exact path="/checkout">
        <CheckOut cart={cart}  user={user} order={order}  onCaptureCheckout={handleCaptureCheckout} addresses={addresses} handleDeleteAddress={handleDeleteAddress} showAddresses={showAddresses} setAddresses={setAddresses} setShowAddresses={setShowAddresses} setAddaddress={setAddaddress} checkInCompletePayments={checkInCompletePayments} medialinks={medialinks} showAds={showAds} t={t}  handleFocus={handleFocus}
         handleBlur={handleBlur} setMessage={setMessage}setOpenSnackBar={setOpenSnackBar}/>
      </Route>
       <Route exact path="/orders">
       <Box  className={classes.content}>
       {
         myOrders ? <Orders orders={myOrders} setMyOrders={setMyOrders} userid={userid} user={user} setShowProgress={setShowProgress} onStatusUpdate={handleUpdateOrder} authenticateToken={authenticateToken} setMessage={setMessage} setOpenSnackBar={setOpenSnackBar} rateStore={rateStore} rateProduct={rateProduct} updateAppcredits={updateAppcredits} isOrdersSorted={isOrdersSorted} setisOrdersSorted={setisOrdersSorted} showAds={showAds} handlerequestRefund={handlerequestRefund} selectedOrder={selectedOrder}setSelectedOrder={setSelectedOrder} t={t} translateStatus={translateStatus}/>:''
       }
       </Box>

        </Route>
         <Route exact path="/orders/details/:orderId">
       <Box  className={classes.contnt}>
       {
         myOrders ? <OrderDetails  userid={userid} user={user}  store={store} order={selectedOrder} myOrders={myOrders} setMyOrders={setMyOrders}  /*setShowDetails={setShowDetails}showDetails={showDetails}  onReviewClick={handleonReviewClick} */ onStatusUpdate={handleUpdateOrder} setMessage={setMessage} setOpenSnackBar={setOpenSnackBar} rateStore={rateStore} rateProduct={rateProduct} updateAppcredits={updateAppcredits} setisOrdersSorted={setisOrdersSorted} handlerequestRefund={handlerequestRefund} t={t} translateStatus={translateStatus} />:''
       }
       </Box>

        </Route>
        <Route exact path='/chat/:buyerId/:sellerId/:openby'>
          { user ? <Box  className={classes.contet}>
                  {/*  <ChatRoom userid={user._id} t={t}/> */}
                 {/*  <WebsocketChat transactionId={user} t={t} /> */}
            </Box>:'...'}
        </Route>
       <Route exact path="/proceedcheckout">
         <ProceedCheckOut onAddToCart={handleAddtoCart}  showAds={showAds}  onUpdateLikes={handleUpdateLikes} favorites={favorites} setOpenModal={setOpenModal} loadMore={loadMore} LoadingMore={LoadingMore} setLoadingMore={setLoadingMore} noMoreProducts={noMoreProducts} setShowProgress={setShowProgress} medialinks={medialinks} adsImages={adsImages} hoplinks={hoplinks} langcode={langcode}/>
       </Route>
       <Route exact path='/prefaredstylecheckout' >
       </Route>
        <Route path="/login">
          <LogIn/>
        </Route>
         <Route path="/signup">
          <SignUp/>
        </Route>
        <Route path="/account">
        {user ?
          <Account stores={stores} setStore={setStore} userObj={userObj}setUserObj={setUserObj} user={user} setUser={setUser} loggedin={loggedin}setLoggedin={setLoggedin} handleLoadUser={handleLoadUser} setOrder={setOrder} setCart={setCart}appcredits={appcredits} setMessage={setMessage} setOpenSnackBar={setOpenSnackBar}  deviceType={deviceType} authenticateToken={authenticateToken} handleLogOut={handleLogOut} emailverified={emailverified} handleSendConfirmationCode={handleSendConfirmationCode} handleConfirmedUser={handleConfirmedUser} setEmailVerified={setEmailVerified}  showprogress={showprogress} setShowProgress={setShowProgress} visited={visited} setVisited={setVisited}  updateAppcredits={updateAppcredits} claimedReward={claimedReward} signIn={signIn} setUsercountryscope={setUsercountryscope} getRecentProductsByscope={getRecentProductsByscope} notification={notification} showNotification={showNotification} setShowNotification={setShowNotification} handleVisitsClaim={handleVisitsClaim} nextClaimAvailable={nextClaimAvailable} setNextClaimAvailable={setNextClaimAvailable}
          handleFocus={handleFocus} handleBlur={handleBlur}
          langcode={langcode}setLangCode={setLangCode} browser={browser}/> :  <Login handleNavigatePage={handleNavigatePage} handleSignIn={handleSignIn} t={t} />}
         
        </Route>
        <Route exact path={paths}>
          
          {keyboardVisible ? '' :<Suspense fallback={<BottomNavFallback/>}> <BottomNav onBottomNavChange={ handleOnBottomNavChange}  totalItems={itemsCount} orderItems={myOrders.length} stores={stores} notification={notification}/></Suspense>}
          
        </Route>
        <Route path="/privacy">
         <div style={{ padding:' 5% 5%'}} ><Privacy/></div> 
         </Route>

         <Route path="/terms">
         <div style={{ padding:' 5% 5%'}} ><Terms/></div> 
         </Route>
         <Route path="/about">
         <AboutUs/>
         </Route>
          </Grid>

          <Grid item  xs={0} sm={0} md={0} lg={1}>

          </Grid>
        </Grid>


      
       {/*  
        <Route path="/dashboard">
           <Dashboard setMessage={setMessage} setOpenSnackBar={setOpenSnackBar}/>
        </Route> */}
    
        <Route path="/settings">
           <Settings handleUpdateOrder={handleUpdateOrder} setShowProgress={setShowProgress} showprogress={showprogress}authenticateToken={authenticateToken} setMessage={setMessage}setOpenSnackBar={setOpenSnackBar} handlepostMessage={handlepostMessage}/>
        </Route>
       
        
         <Route path="/contact">
         <ContactUs setMessage={setMessage} setOpenSnackBar={setOpenSnackBar}/>
         </Route>
        <Route path="/email/confirm">
        <Confirm  setEmailVerified={setEmailVerified}/>
      </Route>
       
       <Route exact path={['/']}>
          <Footer/>
        </Route>
       
     { 
        message.body!==''? <CustomizedSnackbar openSnackBar={openSnackBar} setOpenSnackBar={setOpenSnackBar}
        message={message.body} 
        severity={message.severity}
        variant={'outlined'}
        verticalPosition={"top"} 
        horizontalPosition={'center'}
        transition={'slide'}
        deviceType={deviceType}
     />:''
       }
     </Box>{/* } */}
     </ThemeProvider>
     
  );
}

export default App;